import React, { Component, PropTypes } from 'react';
import { RaisedButton } from 'material-ui';

class RaisedButtonWithLoader extends Component {

  render() {
    const { loader, ...extraProps } = this.props;
    if (loader) return <RaisedButton className="loader" label=" " {...extraProps} disabled />;
    return <RaisedButton {...extraProps}/>;
  }
}

RaisedButtonWithLoader.propTypes = {
  loader: PropTypes.any,
};

export default RaisedButtonWithLoader;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/raised-button-with-loader.jsx